import { render, staticRenderFns } from "./GraphDetail82.vue?vue&type=template&id=3666d077&scoped=true"
import script from "./GraphDetail82.vue?vue&type=script&lang=js"
export * from "./GraphDetail82.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3666d077",
  null
  
)

export default component.exports